import React from 'react';
import Expertice from '../homes/Expertise';
import Blog from '../homes/blog';
import { useLanguage } from "../../i18n/LanguageContext";
import PageHeader from '../ui/PageHeader';
import { Box } from '@mui/material';

const AboutP = () => {
  const { t } = useLanguage();

  return (
    <Box sx={{ bgcolor: '#fff' }}>
      <PageHeader
        title={t('aboutPage.title')}
        subtitle={t('aboutPage.subtitle')}
      />
      <Box sx={{ py: { xs: 5, md: 10 } }}>
        <Expertice hideHeader={true} />
      </Box>
      <Box sx={{ pb: 15 }}>
        <Blog hideHeader={true} />
      </Box>
    </Box>
  );
};

export default AboutP;